import { Header, PricingLanding, ContactForm, ContactIntro, Footer} from '../../components';
import { meltenEffect } from '../../utils/Effects';


function scrollEffects() {
  meltenEffect('contact-intro-text');
  meltenEffect('contact-form-wrapper');
  meltenEffect('contact-datas');
}

window.addEventListener("scroll", scrollEffects);
window.addEventListener("touchmove", scrollEffects);


function Pricing() {
  return (
    <>
      <Header title='pricing'/>
      <main className="flex flex-col text-primary">
        <PricingLanding />
        <ContactIntro />
        <ContactForm />
        <Footer />
      </main>
    </>
  );
}

export default Pricing;